module.exports = __webpack_public_path__ + "img/CellCycle-CRC_GSE206552.eecb4cd9.png";